import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

interface INetworkState {
  chainId: number;
}

const initialState: INetworkState = {
  chainId: 8453,
};

const ChainIdSlice = createSlice({
  name: "chainId",
  initialState,
  reducers: {
    setChainId: (state, action: PayloadAction<number>) => {
      state.chainId = action.payload;
    },
    resetChainId: (state) => {
      state.chainId = 8453;
    },
  },
});

export const { setChainId, resetChainId } = ChainIdSlice.actions;

export default ChainIdSlice.reducer;
